import {
	SensorConfigurationsForm,
	SensorFormMode,
} from '@Components/SensorConfigurationForm/SensorConfigurationForm';

import { InfoCard } from '@innovyze/stylovyze';
import React from 'react';
import { SensorType } from '@innovyze/shared-utils';
import { SystemConnection } from '@Types/systemConnections.types';
import { Units } from '@Types/sensorTypes.types';
import { useGlobalization } from '@Translations';
import { SensorConfigFormShape } from '@Types/configurations.types';
import { SensorTroubleshooting } from '@Types/peek';
import { SensorFormChanges } from '@Hooks';

interface FormCardProps {
	formData: SensorConfigFormShape;
	formErrors: SensorConfigFormShape;
	sensorTypes: SensorType[];
	systemConnections: SystemConnection[];
	onUpdateFormData: (
		newFormData: React.SetStateAction<SensorConfigFormShape>,
	) => void;
	onMapChange: (data: string) => void;
	units: Units;
	mode?: SensorFormMode;
	sensorTroubleshooting: Partial<SensorTroubleshooting>;
	isCurrentlyTesting: boolean;
	sensorFormResampleChanges?: Partial<SensorFormChanges>;
}

const FormCard: React.FC<FormCardProps> = (props: FormCardProps) => {
	const {
		sensorTypes,
		systemConnections,
		formData,
		formErrors,
		onMapChange,
		onUpdateFormData,
		units,
		mode,
		sensorTroubleshooting,
		isCurrentlyTesting,
		sensorFormResampleChanges,
	} = props;
	const { t } = useGlobalization();

	return (
		<InfoCard fullHeight title={t('Details')}>
			<SensorConfigurationsForm
				coordinateChange={onMapChange}
				sensorTypes={sensorTypes}
				systemConnections={systemConnections as never}
				updateFormData={onUpdateFormData}
				formData={formData}
				formErrors={formErrors}
				mode={mode || SensorFormMode.EDIT}
				units={units}
				sensorTroubleshooting={sensorTroubleshooting}
				isCurrentlyTesting={isCurrentlyTesting}
				sensorFormResampleChanges={sensorFormResampleChanges}
			/>
		</InfoCard>
	);
};

export default FormCard;
